import mdiTableSync from '~icons/mdi/table-sync';
import help from '~icons/mdi/help';
import triangleSmallDown from '~icons/mdi/triangle-small-down';
import triangleSmallUp from '~icons/mdi/triangle-small-up';
import viewDasboard from '~icons/mdi/view-dashboard';
import pencil from '~icons/mdi/pencil';
import noteText from '~icons/mdi/note-text';
import archive from '~icons/mdi/archive';
import chartBox from '~icons/mdi/chart-box';
import chartPie from '~icons/mdi/chart-pie';
import accountSupervisor from '~icons/mdi/account-supervisor';
import check from '~icons/mdi/check';
import mdiPlus from '~icons/mdi/plus';
import mdiMinus from '~icons/mdi/minus';
import mdiPlusCircle from '~icons/mdi/plus-circle';
import mdiMinusCircle from '~icons/mdi/minus-circle';
import bell from '~icons/mdi/bell';
import formatLineWeight from '~icons/mdi/format-line-weight';
import domain from '~icons/mdi/domain';
import formatListBulleted from '~icons/mdi/format-list-bulleted';
import closeCircle from '~icons/mdi/close-circle';
import closeCircleOutline from '~icons/mdi/close-circle-outline';
import chevronUp from '~icons/mdi/chevron-up';
import chevronDown from '~icons/mdi/chevron-down';
import chevronLeft from '~icons/mdi/chevron-left';
import chevronRight from '~icons/mdi/chevron-right';
import contentSave from '~icons/mdi/content-save';
import close from '~icons/mdi/close';
import upload from '~icons/mdi/upload';
import eyeOff from '~icons/mdi/eye-off';
import eye from '~icons/mdi/eye';
import helpCircleOutline from '~icons/mdi/help-circle-outline';
import calendar from '~icons/mdi/calendar';
import mdiDelete from '~icons/mdi/delete';
import paperclip from '~icons/mdi/paperclip';
import mdiDownload from '~icons/mdi/download';
import mdiAlert from '~icons/mdi/alert';
import dotsHorizontal from '~icons/mdi/dots-horizontal';
import account from '~icons/mdi/account';
import mdiCancel from '~icons/mdi/cancel';
import information from '~icons/mdi/information';
import alertCircle from '~icons/mdi/alert-circle';
import lock from '~icons/mdi/lock';
import mdiNoteEdit from '~icons/mdi/note-edit';
import mdiFile from '~icons/mdi/file';
import bank from '~icons/mdi/bank';
import undo from '~icons/mdi/undo';
import administrator from '~icons/mdi/administrator';
import clipboardTextHistory from '~icons/mdi/clipboard-text-history';
import clipboardText from '~icons/mdi/clipboard-text';
import fileExport from '~icons/mdi/file-export';

export const mdiAliases = {
  'mdi-table-sync': mdiTableSync,
  'mdi-help': help,
  'mdi-triangle-small-down': triangleSmallDown,
  'mdi-triangle-small-up': triangleSmallUp,
  'mdi-view-dashboard': viewDasboard,
  'mdi-pencil': pencil,
  'mdi-note-text': noteText,
  'mdi-archive': archive,
  'mdi-chart-box': chartBox,
  'mdi-chart-pie': chartPie,
  'mdi-account-supervisor': accountSupervisor,
  'mdi-check': check,
  'mdi-lock': lock,
  'mdi-plus': mdiPlus,
  'mdi-minus': mdiMinus,
  'mdi-plus-circle': mdiPlusCircle,
  'mdi-minus-circle': mdiMinusCircle,
  'mdi-bell': bell,
  'mdi-format-line-weight': formatLineWeight,
  'mdi-domain': domain,
  'mdi-format-list-bulleted': formatListBulleted,
  'mdi-close-circle': closeCircle,
  'mdi-close-circle-outline': closeCircleOutline,
  'mdi-chevron-up': chevronUp,
  'mdi-chevron-right': chevronRight,
  'mdi-chevron-down': chevronDown,
  'mdi-chevron-left': chevronLeft,
  'mdi-content-save': contentSave,
  'mdi-close': close,
  'mdi-upload': upload,
  'mdi-eye-off': eyeOff,
  'mdi-eye': eye,
  'mdi-help-circle-outline': helpCircleOutline,
  'mdi-calendar': calendar,
  'mdi-delete': mdiDelete,
  'mdi-paperclip': paperclip,
  'mdi-download': mdiDownload,
  'mdi-alert': mdiAlert,
  'mdi-dots-horizontal': dotsHorizontal,
  'mdi-account': account,
  'mdi-cancel': mdiCancel,
  'mdi-information': information,
  'mdi-alert-circle': alertCircle,
  'mdi-note-edit': mdiNoteEdit,
  'mdi-file': mdiFile,
  'mdi-bank': bank,
  'mdi-undo': undo,
  'mdi-administrator': administrator,
  'mdi-clipboard-text-history': clipboardTextHistory,
  'mdi-clipboard-text': clipboardText,
  'mdi-file-export': fileExport
};
